import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import BaseModal from "../../../../room-booking-management/calendar/components/BaseModal.vue";
import ConflictTable from "./ConflictTable.vue";
import {
	conflictDetailKey,
	conflictPartnerLabel,
	conflictSubjectLabel,
	formatConflictDate,
} from "../../../conflictFormat";


export default {
  __name: 'ConflictConfirmModal',
  props: {
	show: { type: Boolean, default: false },
	// Raw `conflicts` array from the conflict pre-check (each: { date, time, levels, details }).
	conflicts: { type: Array, default: () => [] },
},
  emits: ["close", "confirm"],
  setup(__props) {

const props = __props;



// One row per distinct conflict (same level + same partner), collapsing recurring conflicts into a
// single row that lists all affected dates.
const rows = computed(() => {
	const groups = new Map();
	for (const conflict of props.conflicts || []) {
		const date = formatConflictDate(conflict.date);
		for (const detail of conflict.details || []) {
			const key = conflictDetailKey(detail);
			if (!groups.has(key)) {
				groups.set(key, {
					level: detail.level,
					subject: conflictSubjectLabel(detail),
					partner: conflictPartnerLabel(detail.with),
					dates: new Set(),
				});
			}
			groups.get(key).dates.add(date);
		}
	}
	return [...groups.values()].map((group) => ({
		level: group.level,
		when: [...group.dates].join(", "),
		subject: group.subject,
		partner: group.partner,
	}));
});

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(BaseModal, {
    show: __props.show,
    title: "Terminkonflikte",
    size: "lg",
    "modal-id": "conflictConfirmModal",
    onClose: _cache[2] || (_cache[2] = $event => (_ctx.$emit('close')))
  }, {
    body: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mb-3" }, [
        _createElementVNode("i", { class: "fas fa-triangle-exclamation text-warning me-2" }),
        _createTextVNode(" Es wurden Terminkonflikte gefunden. Möchtest du den Termin trotzdem speichern? ")
      ], -1 /* CACHED */)),
      _createVNode(ConflictTable, {
        rows: rows.value,
        "when-label": "Termin(e)"
      }, null, 8 /* PROPS */, ["rows"])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close')))
      }, " Abbrechen "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-warning",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('confirm')))
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("i", { class: "fas fa-triangle-exclamation me-1" }, null, -1 /* CACHED */),
        _createTextVNode(" Trotzdem speichern ", -1 /* CACHED */)
      ]))])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show"]))
}
}

}